import Vue from 'vue';
import VueRouter from 'vue-router';
// import { requestAuth, requestBillTypeList } from '@/apis/auth';

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export const routes = [
  {
    path: '/',
    redirect: '/qe/metaManage'
  },
  {
    path: '/no-auth',
    name: 'noAuth',
    component: () =>
      import(/* webpackChunkName: "no-auth" */ '@/views/no-auth.vue')
  },
  {
    path: '/qe/metaManage',
    name: 'qeMetaManage',
    component: () =>
      import(
        /* webpackChunkName: "metaManage" */ '@/views/meta-data/index.vue'
      ),
    meta: {
      title: '元数据管理'
    }
  },
  {
    path: '/qe/query',
    name: 'qeQuery',
    component: () =>
      import(/* webpackChunkName: "qeQuery" */ '@/views/data-query/index.vue'),
    meta: {
      title: '数据查询',
      keepAlive: true
    }
  },
  {
    path: '/qe/task',
    name: 'qeTaskHistory',
    component: () =>
      import(
        /* webpackChunkName: "qeTaskHistory" */ '@/views/query-history/index.vue'
      ),
    meta: {
      title: '查询历史'
    }
  },
  {
    path: '/qe/saveSql',
    name: 'qeSaveSql',
    component: () =>
      import(/* webpackChunkName: "qeSaveSql" */ '@/views/save-sql/index.vue'),
    meta: {
      title: '保存SQL'
    }
  },

  {
    path: '/qe/jdbc',
    name: 'jdbc',
    component: () =>
      import(/* webpackChunkName: "jdbc" */ '@/views/jdbc/index.vue'),
    meta: {
      title: 'JDBC访问'
    }
  },

  {
    path: '/qe/jdbcAuth',
    name: 'jdbcAuth',
    component: () =>
      import(/* webpackChunkName: "jdbcAuth" */ '@/views/jdbc/Auth.vue'),
    meta: {
      title: '权限管理',
      isForbiddenSub: true
    }
  },

  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '@/views/Error.vue')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Auth.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Auth.vue')
  }
];

const router = new VueRouter({
  routes
});

export default router;
